<template>
  <div id="app">
    <notifications group="default" />
    <SiteHeader v-if="showNav"></SiteHeader>
    <BookedNotification/>
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath"/>
    </transition>
  </div>
</template>

<script>
import * as fb from '@/library/firebase'
import { mapState, mapMutations } from 'vuex'
import SiteHeader from '@/components/SiteHeader'
import BookedNotification from '@/components/BookedNotification'
export default {
  components: {
    BookedNotification,
    SiteHeader
  },
  computed: {
    ...mapState([
      'queriedUserProfile',
      'userProfile',
    ]),
    showNav() {
      return this.userProfile ? Object.keys(this.userProfile).length > 1 : false;
    }
  },
  mounted() {
    this.getUserProfile();
    this.loadDataIntoState();
  },
  methods: {
    ...mapMutations([
      'setAdminEmail',
      'setPackages',
      'setQueriedUserProfile'
    ]),
    loadDataIntoState() {
      // Load packages
      let packages = {}
      fb.packagesCollection.get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
          packages[doc.id] = doc.data()
        })
        this.setPackages(packages)
      })
      .catch(error => {
        console.log("Error getting documents: ", error)
      })

      // Set admin email in state
      fb.settingsCollection.doc('all').get().then(doc => {
        this.setAdminEmail(doc.data().adminEmail)
      })
    },
    async getUserProfile() {
      const userId = this.$route.query?.uid
      if (userId) {
        await fb.usersCollection.doc(userId).get().then(doc => {
          const profile = doc.data()
          this.setQueriedUserProfile(profile)
        })
      }
      else {
          this.setQueriedUserProfile(null);
      }
    }
  },
  watch: {
    // call again the method if the route changes
    '$route': 'getUserProfile'
  }
}
</script>
<style lang="scss">
body {
	margin: 0;
	color: $dark;
	background: #E6ECF0;
}
// Hide the first two "remove" links because user has to have at least 2 figures
.formulate-input-grouping .formulate-input-group-repeatable:nth-child(1) .formulate-input-group-repeatable-remove,
.formulate-input-grouping .formulate-input-group-repeatable:nth-child(2) .formulate-input-group-repeatable-remove {
  display: none;
}
.formulate-input-element--radio input:focus + label,
.formulate-input[data-classification=select] select:focus {
  border-color: $dark !important;
}
// Notifications
.vue-notification {
  font-size: 1rem !important;
  background-color: #fff !important;
  border-left-color: #29b8bc !important;
  color: #666 !important;
  .notification-title {
    color: #999;
  }
  &.success {
    background-color: #fff !important;
    border-left-color: #29b8bc !important;
    .notification-title {
      color: #29b8bc;
    }
  }
  &.error {
    background-color: #fff !important;
    border-left-color: $error !important;
    .notification-title {
      color: $error;
    }
  }
  .notification-title {
    margin-bottom: .25rem;
  }
}
</style>